import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import "./index.scss";

import ContentBox from "../../../../../components/ui/ContentBox";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import Button from "../../../../../components/ui/Button";
import Pagination from "../../../../../components/ui/Pagination";
import PaginationArrow from "../../../../../components/ui/PaginationArrow";
import CustomToolTip from "../../../../../components/ui/Tooltip";
import RadioButton from "../../../../../components/ui/RadioButton";
import { toaster } from "../../../../../components/ui/Toaster";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import OverflowText from "../../../../../components/ui/Textoverflow";

import ListFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/ListFilter";
import EndpointsFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/EndpointFilter";

import { plusIcon, minusIcon, searchIcon, viewMoreIcon, infoBlueIcon } from "../../../../../utils/icons";
import { formatDate, formatNumber, getloggedInUserType } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getExternalDetectedList, getAffectedEndpointList, getScanInfoStats, resetScanInfoStats, updateListData, resetUpdateListDataResponse, resetExternalDetectedList } from "../../../../../store/actions/scanInfoAction";

const MisConfiguration = () => {

    const misConfigurationListResponse = useSelector((state) => state.scanInfo?.misconfigurationList);
    const afftectedEndpointsList = useSelector((state) => state.scanInfo.afftectedEndpointList);
    const misconfigurationStatsResponse = useSelector((state) => state.scanInfo?.scanInfoStats);
    const updateStatusListResponse = useSelector((state) => state?.scanInfo?.updateStatusList);

    const viewMoreWrapperRef = useRef(null);
    const updateUrl = apiEndpoints.scanInfo.exposureManagemnet.externalDetectedVulnerabilities.misConfiguration

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
        triggerListFetch,
        setTriggerListFetch,
        setContextCurrentPage
    } = useScanInfoContext();

    const [activeContent, setActiveContent] = useState("affectedEndpoints");
    const [selectedSubdomainTakeOver, setSelectedSubdomainTakeOver] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isEndpointLoading, setIsEndpointLoading] = useState(false);
    const [showExtractDataModal, setShowExtractDataModal] = useState(false);
    const [extractedData, setExtractedData] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [scanNotFound, setScanNotFound] = useState(false);
    const [listCurrentPage, setListCurrentPage] = useState(1);
    const [misconfigurationStats, setMisconfigurationStats] = useState("");
    const [showViewAllModal, setShowViewAllModal] = useState(false);
    const [statsLoading, setStatsLoading] = useState(false);
    const [misConfigurationList, setMisConfigurationList] = useState(null);
    // modal state
    const [showActionModal, setShowActionModal] = useState(false);
    const [viewAllType, setViewAllType] = useState("");
    const [modalType, setModalType] = useState("")
    const [selectedData, setSelectedData] = useState("");
    const [modalLoading, setModalLoading] = useState(false);
    const [showViewMore, setShowViewMore] = useState(false);
    const [selectedValid, setSelectedValid] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedSeverity, setSelectedSeverity] = useState("");

    //list search state
    const [listSearch, setListSearch] = useState("");
    const [updatedListSearchValue, setUpdatedListSearchValue] = useState("");

    //affected endpoint search state
    const [endpointSearch, setEndpointSearch] = useState("");
    const [endpointsQuery, setEndpointsQuery] = useState("");
    const [endpointSearchFocused, setEndpointSearchFocused] = useState(false);

    //selected list filter
    const [listFilterValue, setListFilterValue] = useState({});

    //endpoint filter
    const [endpointFiltersValue, setEndpointFiltersValue] = useState({})
                        
    const handlePageChange = (newPage) => {
        setListCurrentPage(newPage);
        setContextCurrentPage(newPage);
        setTriggerListFetch(true);
    };

    const showContent = (data) => {  
        if(activeContent === data) {
            setActiveContent("")
        } else {
            setActiveContent(data)
            if(data === "affectedEndpoints") {
                fetchAffectedEndPoints()
            }
        }
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && endpointSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setEndpointsQuery(endpointSearch)
    }

    const listFilterApply = (data) => {
        setListCurrentPage(1);
        setListFilterValue(data);
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const isAnyFilterActive = Object.values(listFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setListCurrentPage(1);
        setListFilterValue({});
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const fetchMisconfigurationStats = useCallback(()=>{
        setStatsLoading(true)
        const baseUrl = `${updateUrl.misconfiurationStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getScanInfoStats(url))
    },[dispatch, domainId, scanId, organizationId, updateUrl])

    const endPointFilterApply = (data) => {
        setCurrentPage(1)
        setEndpointFiltersValue(data)
    }

    const isAnyEndpointFilterActive = Object.values(endpointFiltersValue).some(value => Boolean(value));

    const resetEndpointFilterValue = () => {
        setCurrentPage(1)
        setEndpointFiltersValue({})
    }

    const fetchAffectedEndPoints = useCallback(()=>{
        setIsEndpointLoading(true)
        const baseUrl = `${updateUrl.misConfigurationEndpoints()}&page=${currentPage}&page_size=${currentPageSize}&domain=${selectedSubdomainTakeOver?.domain}&scan_id=${selectedSubdomainTakeOver?.scan_id}&result_id=${selectedSubdomainTakeOver?.id}`;
        const queryParams = endpointsQuery ? `&query=${endpointsQuery}` : "";
        const newFindings = endpointFiltersValue?.newFindings?.value && endpointFiltersValue?.newFindings?.value !== "all" ? `&new_record=${endpointFiltersValue?.newFindings?.value === "yes" ? true : false}` : "";
        const falsePositive = endpointFiltersValue?.falsePositive?.value && endpointFiltersValue?.falsePositive?.value !== "all" ? `&false_positive=${endpointFiltersValue?.falsePositive?.value === "yes" ? true : false}` : "";
        const status = endpointFiltersValue?.status?.value && endpointFiltersValue?.status?.value !== "all" ? `&status=${endpointFiltersValue?.status?.value}` : "";
        const severity = endpointFiltersValue?.severity?.value && endpointFiltersValue?.severity?.value !== "all" ? `&severity=${endpointFiltersValue?.severity?.value}` : "";
        const url = `${baseUrl}${queryParams}${newFindings}${falsePositive}${status}${severity}`;
        dispatch(getAffectedEndpointList(url));
    },[dispatch, currentPage, currentPageSize, selectedSubdomainTakeOver, updateUrl, endpointsQuery, endpointFiltersValue])

    const requestSearch = useMemo(() => debounce((searchTerm) => {        
        setUpdatedListSearchValue(searchTerm)
    }, 500), []);

    const fetchMisconfigurationList = useCallback(()=>{
        setIsLoading(true)
        setScanNotFound(false)
        const baseUrl = `${updateUrl.misConfigurationList()}&page=${listCurrentPage}&page_size=10`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = updatedListSearchValue ? `&query=${updatedListSearchValue}` : "";
        const newFindings = listFilterValue?.newFindings?.value && listFilterValue?.newFindings?.value !== "all" ? `&new_record=${listFilterValue?.newFindings?.value === "yes" ? true : false}` : "";
        const status = listFilterValue?.status?.value && listFilterValue?.status?.value !== "all" ? `&status=${listFilterValue?.status?.value}` : "";
        const severity = listFilterValue?.severity?.value && listFilterValue?.severity?.value !== "all" ? `&severity=${listFilterValue?.severity?.value}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}${status}${severity}`;
        dispatch(getExternalDetectedList(url, "misconfigurationList"))
    },[dispatch, domainId, scanId, organizationId, listCurrentPage, updateUrl, updatedListSearchValue, listFilterValue])

    const confirmDelete = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            endpoint_id: selectedData?.id
        }
        dispatch(updateListData(updateUrl.misconfigurationDelete(), obj))
    }

    const saveUpdate = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            endpoint_id: selectedData?.id,
            false_positive: selectedValid === "valid" ? false : true
        }
        dispatch(updateListData(updateUrl.misconfigurationValidate(), obj))
    }

    const updateStatus = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            endpoint_id: selectedData?.id,
            status: selectedStatus
        }
        dispatch(updateListData(updateUrl.misconfigurationStatus(), obj))
    }

    const updateSeverity = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            endpoint_id: selectedData?.id,
            severity: selectedSeverity
        }
        dispatch(updateListData(updateUrl.misConfigurationSeverity(), obj))
    }

    const updateRetest = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            endpoint_id: selectedData?.id
        }
        if(modalType === "start") {
            dispatch(updateListData(updateUrl.misconfigurationStart(), obj))
        } else {
            dispatch(updateListData(updateUrl.misconfigurationStop(), obj))
        }
    }

    useEffect(() => {
        if (selectedSubdomainTakeOver) {
            setCurrentPage(1);
        }
    }, [selectedSubdomainTakeOver]);

    useEffect(()=>{
        if(selectedSubdomainTakeOver?.id) {
            fetchAffectedEndPoints()
        }        
    },[currentPage, selectedSubdomainTakeOver, fetchAffectedEndPoints])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchMisconfigurationStats();
            setListCurrentPage(1);
            setContextCurrentPage(1)
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setContextCurrentPage, setTriggerStatsFetch, fetchMisconfigurationStats]);

    useEffect(() => {
        if (triggerListFetch) {
            fetchMisconfigurationList();
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch, fetchMisconfigurationList]);

    useEffect(() => {
        setListCurrentPage(1); // reset to first page
        setContextCurrentPage(1);
        setTriggerListFetch(true); // trigger fetch
    }, [setTriggerListFetch, setContextCurrentPage, updatedListSearchValue]);

    useEffect(()=>{
        if(misConfigurationListResponse !== null) {
            setMisConfigurationList(misConfigurationListResponse)
            if(misConfigurationListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            if(misConfigurationListResponse?.results?.length > 0) {
                setIsEndpointLoading(true)
                setSelectedSubdomainTakeOver(misConfigurationListResponse?.results[0]);
            }
            dispatch(resetExternalDetectedList("misconfigurationList"))
            setIsLoading(false)
        }
    },[misConfigurationListResponse, dispatch])

    useEffect(()=>{
        if(afftectedEndpointsList !== null){
            setIsEndpointLoading(false)
        }
    },[afftectedEndpointsList])

    useEffect(()=>{   
        if(misconfigurationStatsResponse !== null) {
            setStatsLoading(false)
            setMisconfigurationStats(misconfigurationStatsResponse)
            dispatch(resetScanInfoStats())
        }
    },[misconfigurationStatsResponse, dispatch])

    useEffect(()=>{
        if(updateStatusListResponse !== null) {
            setShowActionModal(false)
            setModalLoading(false)
            if(updateStatusListResponse?.status === "success") {
                toaster.addToast(updateStatusListResponse?.description,"success")
                fetchAffectedEndPoints()
            } else {
                toaster.addToast(updateStatusListResponse?.description,"error")
            }
            dispatch(resetUpdateListDataResponse())
        }
    },[updateStatusListResponse, fetchAffectedEndPoints, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (viewMoreWrapperRef.current && !viewMoreWrapperRef.current.contains(event.target)) {
                if(showViewMore){
                    setShowViewMore(false)
                }
            }        
        }
    },[showViewMore])


    return (
        <>
            <div className="scan-info-main-content sensitive-exposure-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>
                        <Col lg={3}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"misconfiguration"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="discover-doamin-container associated-doamin-page rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Misconfiguration</p>
                                        </div>
                                        <div className="total-score-container rounded">
                                            <div className="users-totol-count d-flex">
                                                <p className="total-score-count">{formatNumber(misconfigurationStats?.record_type?.total)}</p>
                                                <div className="score-count mx-3">
                                                    <span className="new-record d-inline-block mx-1"></span>
                                                    <span className="existing-record d-inline-block"></span>
                                                    <p>Total Records</p>
                                                </div>
                                            </div>
                                            <div className="new-exist-count d-flex gap-5 mt-3">
                                                <p className="new-record"><span className="d-inline-block">{formatNumber(misconfigurationStats?.record_type?.new_record)}</span> New</p>
                                                <p className="existing-record"><span className="d-inline-block">{formatNumber(misconfigurationStats?.record_type?.existing_record)}</span> Existing</p>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                        <Col lg={3}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"misconfiguration"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="discover-doamin-container associated-doamin-page rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Severity</p>
                                            <p className="view-all" onClick={()=>{
                                                setViewAllType("severity")
                                                setShowViewAllModal(true)
                                            }}>View all</p>
                                        </div>
                                        <div className="total-score-container rounded">
                                            <div className="users-totol-count d-flex align-items-baseline">
                                                <p className="total-score-count">{formatNumber(misconfigurationStats?.severity_type?.total)}</p>
                                                <div className="score-count mx-3">
                                                    <p>Total Risk</p>
                                                </div>
                                            </div>
                                            <div className="new-exist-count d-flex align-items-center gap-5 mt-3">
                                                <p className="severity critical"><span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.critical)}</span> Critical</p>
                                                <p className="severity high"><span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.high)}</span> High</p> 
                                            </div>
                                            <div className="new-exist-count d-flex align-items-center gap-5 mt-3">
                                            <p className="severity medium"><span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.medium)}</span> Medium</p>
                                                <p className="severity low"><span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.low)}</span> Low</p>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                        <Col lg={3}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"misconfiguration"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="discover-doamin-container associated-doamin-page rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Status</p>
                                        </div>
                                        <div className="total-score-container rounded">
                                            <div className="users-totol-count d-flex">
                                                <p className="total-score-count">{formatNumber(misconfigurationStats?.status_type?.total)}</p>
                                                <div className="score-count mx-3">
                                                    <span className="new-record open d-inline-block mx-1"></span>
                                                    <span className="existing-record closed d-inline-block"></span>
                                                    <span className="existing-record informational d-inline-block mx-1"></span>
                                                    <p>Total Records</p>
                                                </div>
                                            </div>
                                            <div className="new-exist-count d-flex gap-5 mt-3">
                                                <p className="new-record open"><span className="d-inline-block">{formatNumber(misconfigurationStats?.status_type?.open)}</span> Open</p>
                                                <p className="existing-record closed"><span className="d-inline-block">{formatNumber(misconfigurationStats?.status_type?.closed)}</span> Closed</p>
                                            </div>
                                            <div className="new-exist-count d-flex gap-5 mt-3">
                                                <p className="existing-record informational"><span className="d-inline-block">{formatNumber(misconfigurationStats?.status_type?.wont_fix)}</span> Won't Fix</p>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                        <Col lg={3}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"misconfiguration"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="sub-domain-type-container rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Misconfiguration Type</p>
                                            {misconfigurationStats !== "" && misconfigurationStats?.misconfiguration_type?.records && Object.entries(misconfigurationStats?.misconfiguration_type?.records).length > 4 && <p className="view-all" onClick={()=>{
                                                setViewAllType("type")
                                                setShowViewAllModal(true)
                                            }}>View all</p>}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{formatNumber(misconfigurationStats?.misconfiguration_type?.total)} <span>Total Records</span></p>
                                        </div>
                                        <Row className="mt-3">
                                            {
                                                misconfigurationStats !== "" && misconfigurationStats?.misconfiguration_type?.records && Object.entries(misconfigurationStats?.misconfiguration_type?.records).length > 0 &&
                                                Object.entries(misconfigurationStats?.misconfiguration_type?.records).map(([key, value], index) => {
                                                    if(index <= 3) {
                                                        return (
                                                            <Col lg={6} key={index}>
                                                                <p className="count-type sensitive-expo-count mt-2">
                                                                {formatNumber(value)} <span>{key}</span>
                                                                </p>
                                                            </Col>
                                                        )
                                                    }
                                                    return null;
                                                })
                                            }
                                        </Row>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                    </Row>
                </div>
                <div className="mt-3">
                    <div className="js-secrets-main-content">
                        <Row>
                            <Col lg={3}>
                                <div className="bg-white-with-shadow subdomain-list-container h-100">
                                    <div className="list-heading px-3 pt-3 d-flex justify-content-between align-items-center">
                                        <h1>Misconfiguration List</h1>
                                        {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                        <ListFilter listFilterApply={listFilterApply} listFilterValue={listFilterValue} currentPage={"default"} />
                                    </div>
                                    <div className="search-container px-3 position-relative">
                                        <span className="position-absolute search-icon">{searchIcon()}</span>
                                        <input type="text" 
                                            placeholder="Search" 
                                            className="w-100 rounded input"
                                            value={listSearch}
                                            onChange={(e)=>{                                                
                                                setListSearch(e.target.value);
                                                requestSearch(e.target.value);
                                                setListCurrentPage(1);
                                                setContextCurrentPage(1);
                                                setTriggerListFetch(true);
                                            }}
                                        />
                                    </div>
                                    <div className="list-main-container js-secrets-list sensitive-exposure-list">
                                        { !isLoading && scanNotFound &&
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4 }}
                                            >
                                                <NoDataFound noDataText={misConfigurationList?.description}/>
                                            </motion.div>
                                        }
                                        {
                                            isLoading && !scanNotFound ?
                                            <SkeletonLoader type={"line"} count={5} currentPage={"misconfiguration"} />
                                            :
                                            (
                                                misConfigurationList?.results?.length > 0 &&
                                                misConfigurationList?.results?.map((data, index)=>{
                                                    return (
                                                        <motion.div
                                                            key={index}
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                                        >
                                                            <div className={`sub-domain-list py-2 px-3 ${selectedSubdomainTakeOver?.id === data?.id ? "active" : ""}`} key={index} onClick={()=>{
                                                                resetEndpointFilterValue()
                                                                setSelectedSubdomainTakeOver(data)
                                                                }}>
                                                                <div className={`d-flex align-items-center subdomain-name gap-2 mb-2 ${!data?.new_record ? "full-width" : ""}`}>
                                                                    <OverflowText text={data?.name} className={"sub-domain-heading"}/>
                                                                    {data.new_record && <span className="new-subdomain">New</span>}
                                                                </div>
                                                                <p className="sub-domain-name">{data?.domain}</p>
                                                                <div className="d-flex status-container">
                                                                    <p className="severity">Severity: &nbsp; 
                                                                        {data?.severity === "critical" && <span className="critical">{data?.severity}</span>}
                                                                        {data?.severity === "high" && <span className="high">{data?.severity}</span>}
                                                                        {data?.severity === "medium" && <span className="medium">{data?.severity}</span>}
                                                                        {data?.severity === "low" && <span className="low">{data?.severity}</span>}
                                                                        {data?.severity === "informational" && <span className="informational">Info</span>}
                                                                        {data?.severity === "unknown" && <span className="unknown">Unknown</span>}
                                                                    </p>
                                                                    <div className="status-container">
                                                                        {data.status === "open" && <p className="open">Status: <span>Open</span></p>}
                                                                        {data.status === "closed" && <p className="closed">Status: <span>Closed</span></p>}
                                                                        {data.status === "wont_fix" && <p className="inprogress">Status: <span>Won't Fix</span></p>}
                                                                    </div>                                                            
                                                                </div>
                                                                <div className="status-container mt-2">
                                                                    <p className="affected-endpoint">Affected Endpoints: <span>{data?.endpoints?.total}</span></p>
                                                                </div>                                                        
                                                            </div>
                                                        </motion.div>
                                                    )
                                                })
                                            )
                                        }
                                        { !isLoading && misConfigurationList?.results?.length > 0 &&
                                            <PaginationArrow 
                                                totalCount={misConfigurationList?.meta?.total_results}
                                                currentPage={listCurrentPage}
                                                onPageChange={handlePageChange}
                                            />                                  
                                        }
                                        { !isLoading && misConfigurationList?.results?.length === 0 &&
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4 }}
                                            >
                                                <NoDataFound noDataText={"No Data Found"} />
                                            </motion.div>
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col lg={9}>
                                <div className="main-content bg-white-with-shadow p-2 h-100">
                                    {
                                        !isLoading && scanNotFound ?
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={misConfigurationList?.description}/>
                                        </motion.div>
                                        :
                                        (
                                            !isLoading && misConfigurationList?.results?.length === 0 ?
                                                <motion.div
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4 }}
                                                >
                                                    <NoDataFound noDataText={"No Data Found"}/>
                                                </motion.div>
                                            :
                                            <>
                                                <div className="record-container-content p-2">
                                                    <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{showContent("jsSecretsSummary")}}>
                                                        <h2 className="heading">Misconfiguration Summary</h2>
                                                        {activeContent === "jsSecretsSummary" ? minusIcon() : plusIcon()}
                                                    </div>
                                                    {
                                                        isLoading && activeContent === "jsSecretsSummary" ?
                                                            <SkeletonLoader type={"line"} count={5} currentPage={"sensitiveExpo"} />
                                                        :
                                                        <>
                                                            {activeContent === "jsSecretsSummary" && <div className="js-secrete-summary mt-3">
                                                                <motion.div
                                                                    initial={{ opacity: 0, y: 20 }}
                                                                    animate={{ opacity: 1, y: 0 }}
                                                                    transition={{ duration: 0.4 }}
                                                                >
                                                                    <Row>
                                                                        <Col lg={6} className="mb-3">
                                                                            <ContentBox label={"Name"} value={selectedSubdomainTakeOver?.name}/>
                                                                        </Col>
                                                                        <Col lg={6} className="mb-3">
                                                                            <ContentBox label={"Description"} value={selectedSubdomainTakeOver?.description}/>
                                                                        </Col>
                                                                        <Col lg={6} className="mb-3">
                                                                            <div className="content-box-container p-3 rounded h-100">
                                                                                <h4 className="label">Severity</h4>
                                                                                <p className="value severity">{selectedSubdomainTakeOver?.severity}</p>
                                                                            </div>
                                                                        </Col>
                                                                        <Col lg={6} className="mb-3">
                                                                            <ContentBox label={"Remediation"} value={selectedSubdomainTakeOver?.remediation}/>
                                                                        </Col>
                                                                        <Col lg={6} className="mb-3">
                                                                            <div className="content-box-container p-3 rounded h-100">
                                                                                <h4 className="label">Reference</h4>
                                                                                {selectedSubdomainTakeOver !== "" && selectedSubdomainTakeOver?.reference.length > 0 ? <p className="value">{selectedSubdomainTakeOver?.reference.join(", ")}</p> : "-"}                                                        
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </motion.div>
                                                            </div> } 
                                                        </>
                                                    }                   
                                                </div>
                                                <div className="record-container-content p-2 mt-3">
                                                    <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{showContent("affectedEndpoints")}}>
                                                        <h2 className="heading">Affected Endpoints</h2>
                                                        {activeContent === "affectedEndpoints" ? minusIcon() : plusIcon()}
                                                    </div>
                                                    {activeContent === "affectedEndpoints" && <div className="affected-endpoint-container">
                                                        <div className="git-leaks-main-content">
                                                            <div className="search-header-container d-flex align-items-center gap-3 my-3">
                                                                <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                                                                    <div className="search-container position-relative">
                                                                        <span className="position-absolute">{searchIcon()}</span>
                                                                        <input type="text" 
                                                                            placeholder="Search" 
                                                                            value={endpointSearch} 
                                                                            onChange={(e)=>{
                                                                                setEndpointSearch(e.target.value)
                                                                            }}
                                                                            onFocus={() => setEndpointSearchFocused(true)}
                                                                            onBlur={() => setEndpointSearchFocused(false)}
                                                                        />
                                                                    </div>
                                                                    <button className="search-btn" onClick={onSearch}>Search</button>
                                                                </div>
                                                                <EndpointsFilter endPointFilterApply={endPointFilterApply} endpointFiltersValue={endpointFiltersValue} currentPage={"default"} />
                                                                {isAnyEndpointFilterActive && (<span className="reset-filter-link" onClick={resetEndpointFilterValue}>Reset Filter</span>)}
                                                            </div>
                                                            <div className="js-secrets-table">
                                                                {
                                                                    isLoading || isEndpointLoading ?
                                                                    <SkeletonLoader type={"line"} count={5} currentPage={"misconfiguration"} />
                                                                    :
                                                                    <Table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>URL</th>
                                                                                <th>Extracted Data</th>
                                                                                <th>Severity</th>
                                                                                <th>Status</th>
                                                                                <th>First Seen / Last Seen</th>
                                                                                <th>Retest</th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                afftectedEndpointsList?.results?.length > 0 &&
                                                                                afftectedEndpointsList?.results?.map((data, index)=>{
                                                                                    return (
                                                                                        <motion.tr
                                                                                            key={index}
                                                                                            initial={{ opacity: 0, y: 20 }}
                                                                                            animate={{ opacity: 1, y: 0 }}
                                                                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                                                                        >
                                                                                            <td className="url-container">
                                                                                                <a href={data?.url} target="_blank" className="table-url" rel="noreferrer">{data?.url}</a>
                                                                                                {data?.false_positive && <p className="false-positive">False Positive</p>}
                                                                                                {data?.new_record && <div><p className="d-inline-block new-data my-2">New</p></div>}
                                                                                            </td>
                                                                                            <td className="extraction-container">
                                                                                                {(data?.extracted_data !== null && data?.extracted_data !== "") ? <p className="cursor-pointer" onClick={()=>{
                                                                                                    setShowExtractDataModal(true)
                                                                                                    setExtractedData(data?.extracted_data);
                                                                                                }}>view</p>: "-"}
                                                                                            </td>
                                                                                            <td className="severity-container">
                                                                                                <p className={`severity ${data?.severity}`}>{data?.severity}</p>
                                                                                            </td>
                                                                                            <td className="status-container">
                                                                                                {data?.status === "closed" && <p className="status-close">Closed</p>}
                                                                                                {data?.status === "open" && <p className="status-open">Open</p>}
                                                                                                {data?.status === "wont_fix" && <p className="status-warn">Won't Fix</p>}
                                                                                            </td>
                                                                                            <td className="first-seen-container">
                                                                                                <h4 className="verified-details m-0">First Seen:</h4>
                                                                                                <p className="value mb-2">{formatDate(data?.first_seen)}</p>
                                                                                                <h4 className="verified-details m-0">Last Seen:</h4>
                                                                                                <p className="value">{formatDate(data?.last_seen)}</p>
                                                                                            </td>
                                                                                            <td className="retest-summary">
                                                                                                <div className="finding-list">
                                                                                                    <ul type="none" className="m-0 p-0">
                                                                                                        <li className="d-flex justify-content-between gap-3">
                                                                                                            <span>Status: </span>
                                                                                                            {data?.retest?.status === "pending" && 
                                                                                                                <span className="retest-status pending">{data?.retest?.status}</span>
                                                                                                            }
                                                                                                            {data?.retest?.status === "in_progress" && 
                                                                                                                <span className="retest-status inprogress"> In Progress</span>
                                                                                                            }
                                                                                                            {data?.retest?.status === "completed" && 
                                                                                                                <span className="retest-status completed">{data?.retest?.status}</span>                                                                    
                                                                                                            }
                                                                                                            {data?.retest?.status === "failed" && 
                                                                                                                <span className="retest-status failed">Failed
                                                                                                                    {data?.retest?.summary !== null && <CustomToolTip content={data?.retest?.summary } position={"top"}>
                                                                                                                        <span className="info-icon">{infoBlueIcon()}</span>
                                                                                                                    </CustomToolTip>}
                                                                                                                </span>
                                                                                                            }
                                                                                                            {data?.retest?.status === "stopped" && 
                                                                                                                <span className="retest-status stopped">{data?.retest?.status}</span>
                                                                                                            }
                                                                                                            {
                                                                                                                (data?.retest?.status === "" || data?.retest?.status === null) && <span>-</span>
                                                                                                            }
                                                                                                        </li>
                                                                                                        <li className="d-flex justify-content-between gap-3">
                                                                                                            <span>Fixed: </span>
                                                                                                            <span className="retest-status">{
                                                                                                                (data?.retest?.is_fixed !== null && data?.retest?.is_fixed !== "") 
                                                                                                                ? data?.retest?.is_fixed ? "Yes" : "No" : "-"}
                                                                                                                {data?.retest?.summary !== null && data?.retest?.status !== "failed" && <CustomToolTip content={data?.retest?.summary } position={"top"}>
                                                                                                                    <span className="info-icon">{infoBlueIcon()}</span>
                                                                                                                </CustomToolTip>}
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    </ul>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div className="view-more-div position-relative">
                                                                                                    <span onClick={()=>{
                                                                                                        setSelectedData(data)
                                                                                                        setShowViewMore(true)
                                                                                                    }}>{viewMoreIcon()}</span>
                                                                                                    {showViewMore && data.id === selectedData.id && <div className="more-option-container position-absolute" ref={viewMoreWrapperRef}>                                                            
                                                                                                        {getloggedInUserType() === "internal" && <p onClick={()=>{
                                                                                                            setModalType("valid")
                                                                                                            setSelectedValid(data?.false_positive ? "falsePositive" : "valid")                                                             
                                                                                                            setShowActionModal(true)
                                                                                                        }}>Validate</p>}
                                                                                                        <p onClick={()=>{
                                                                                                            setModalType("delete")                                                                
                                                                                                            setShowActionModal(true)
                                                                                                        }}>Delete</p>
                                                                                                        <p onClick={()=>{
                                                                                                            setModalType("updateStatus")
                                                                                                            setSelectedStatus(data?.status)                                                                                                                               
                                                                                                            setShowActionModal(true)
                                                                                                        }}>Update Status</p>
                                                                                                        {getloggedInUserType() === "internal" && <p onClick={()=>{
                                                                                                            setModalType("updateSeverity")
                                                                                                            setSelectedSeverity(data?.severity)
                                                                                                            setShowActionModal(true)
                                                                                                        }}>Update Severity</p>}
                                                                                                        {data?.retest?.status !== "in_progress" && data?.retest?.status !== "pending" ? <p onClick={()=>{
                                                                                                                setModalType("start")
                                                                                                                setShowActionModal(true)
                                                                                                            }}>Start - Retest</p> 
                                                                                                            :
                                                                                                            <p onClick={()=>{
                                                                                                                setModalType("stop")
                                                                                                                setShowActionModal(true)
                                                                                                            }}>Stop - Retest</p>
                                                                                                        }
                                                                                                    </div>}
                                                                                                </div>
                                                                                            </td>
                                                                                        </motion.tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </tbody>
                                                                    </Table>
                                                                }
                                                                {
                                                                    !isEndpointLoading && afftectedEndpointsList !== "" && afftectedEndpointsList?.results?.length === 0 && 
                                                                        <motion.tr
                                                                            initial={{ opacity: 0, y: 20 }}
                                                                            animate={{ opacity: 1, y: 0 }}
                                                                            transition={{ duration: 0.4 }}
                                                                        >
                                                                            <NoDataFound noDataText={"No Record Found"}/>
                                                                        </motion.tr>
                                                                }
                                                                {!isEndpointLoading && afftectedEndpointsList !== "" && afftectedEndpointsList?.results?.length > 0 && <Pagination
                                                                    className="pagination-bar"
                                                                    currentPage={currentPage}
                                                                    pageSize={currentPageSize}
                                                                    totalCount={afftectedEndpointsList?.meta?.total_results}
                                                                    onPageChange={setCurrentPageandRecordSize}
                                                                />}
                                                            </div>
                                                        </div>
                                                    </div>}
                                                </div>
                                            </>
                                        )
                                    }                                    
                                </div>
                            </Col>
                        </Row>
                        <Modal
                            show={showExtractDataModal}
                            onHide={()=>setShowExtractDataModal(false)}
                            size="md"
                            centered
                            className=""
                            >
                                <Modal.Body>                                
                                    <div className="delete-organization-container">
                                        <h4>Extracted Data</h4>
                                        <div className="p-2 m-2">
                                            <p className="extracted-data">{extractedData}</p>
                                        </div>
                                        <div className="d-flex justify-content-center gap-3 m-2">
                                            <div className="w-50">                                                
                                                <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowExtractDataModal(false)}/>
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                        </Modal>
                        <Modal
                            show={showViewAllModal}
                            onHide={()=>setShowViewAllModal(false)}
                            size="md"
                            centered
                            className=""
                            >
                                <Modal.Body>
                                    {viewAllType === "type" && <div className="delete-organization-container">
                                        <h4>Misconfiguration Type</h4>
                                        <div className="p-2 m-2 type-list-container">
                                            <div className="mt-3">
                                                {
                                                    misconfigurationStats !== "" && misconfigurationStats?.misconfiguration_type?.records && Object.entries(misconfigurationStats?.misconfiguration_type?.records).length > 0 &&
                                                    Object.entries(misconfigurationStats?.misconfiguration_type?.records).map(([key, value], index) => {
                                                        return (
                                                            <motion.div
                                                                key={index}
                                                                initial={{ opacity: 0, y: 20 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                                            >
                                                                <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom scan-info-type-modal">
                                                                    <p>{key}</p>
                                                                    <p className="count-type total-count">{formatNumber(value)}</p>
                                                                </div>
                                                            </motion.div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-center gap-3 mt-4">
                                            <div className="w-50">
                                                <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowViewAllModal(false)}/>
                                            </div>
                                        </div>
                                    </div>}
                                    {viewAllType === "severity" &&
                                        <div className="sensitive-exposure-main-content">
                                            <h4>Severity</h4>
                                            <div className="discover-doamin-container associated-doamin-page rounded p-3 h-100">
                                                <div className="total-score-container rounded">
                                                    <div className="new-exist-count">
                                                        <p className="severity critical d-flex align-items-center justify-content-between gap-2 mt-3">Critical<span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.critical)}</span></p>
                                                        <p className="severity high d-flex align-items-center justify-content-between gap-2 mt-3">High<span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.high)}</span></p> 
                                                    </div>
                                                    <div className="new-exist-count">
                                                        <p className="severity medium d-flex align-items-center justify-content-between gap-2 mt-3">Medium<span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.medium)}</span></p>
                                                        <p className="severity low d-flex align-items-center justify-content-between gap-2 mt-3">Low<span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.low)}</span></p>
                                                    </div>
                                                    <div className="new-exist-count">
                                                        <p className="severity info d-flex align-items-center justify-content-between gap-2 mt-3">Informational<span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.informational)}</span></p>
                                                        <p className="severity unknown d-flex align-items-center justify-content-between gap-2 mt-3">Unknown<span className="d-inline-block">{formatNumber(misconfigurationStats?.severity_type?.unknown)}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-center gap-3 mt-4">
                                                <div className="w-50">
                                                    <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowViewAllModal(false)}/>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </Modal.Body>
                        </Modal>
                        <Modal
                            show={showActionModal}
                            onHide={() => setShowActionModal(false)}
                            size="md"
                            centered
                            >
                                {modalType === "delete" && <Modal.Body>
                                    <div className="delete-organization-container">
                                        <h4>Delete</h4>
                                        <div className="organization-related-details p-4 m-2">
                                            <p>Are you sure, want to delete?</p>                                    
                                        </div>
                                        <div className="delete-organization-btn d-flex gap-3 m-2">
                                            <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                            {!modalLoading && <Button buttonText="Delete" buttonType={"primary"} buttonClicked={() => confirmDelete()} />}
                                            {modalLoading && <Button buttonText="Loading..." disableButton={true} buttonType={"secondary"} />}
                                        </div>
                                    </div>
                                </Modal.Body>}
                                {modalType === "valid" && <Modal.Body>
                                    <div className="delete-organization-container">
                                        <h4>Validate</h4>
                                        <div className="organization-related-details p-4 m-2">
                                            <p className="mb-4">Please Select below option</p>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                <RadioButton radioId={1} radioValue={"valid"} radioLabel={"Valid"} onChange={(data)=>{setSelectedValid(data)}} isChecked={selectedValid === "valid"} />
                                                <RadioButton radioId={2} radioValue={"falsePositive"} radioLabel={"False Positive"} onChange={(data)=>{setSelectedValid(data)}} isChecked={selectedValid === "falsePositive"} />
                                            </div>
                                        </div>
                                        <div className="d-flex gap-3 m-2">
                                            <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                            {!modalLoading && <Button buttonText="Save" buttonType={"primary"} disableButton={selectedValid === ""} buttonClicked={() => saveUpdate()} />}
                                            {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                        </div>
                                    </div>
                                </Modal.Body>}
                                {modalType === "updateStatus" && <Modal.Body>
                                    <div className="delete-organization-container">
                                        <h4>Update Status</h4>
                                        <div className="organization-related-details p-4 m-2">
                                            <p className="mb-4">Please Select below option</p>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                <RadioButton radioId={1} radioValue={"open"} radioLabel={"Open"} onChange={(data)=>{setSelectedStatus(data)}} isChecked={selectedStatus === "open"} />
                                                <RadioButton radioId={2} radioValue={"closed"} radioLabel={"Close"} onChange={(data)=>{setSelectedStatus(data)}} isChecked={selectedStatus === "closed"} />
                                                <RadioButton radioId={3} radioValue={"wont_fix"} radioLabel={"Won't Fix"} onChange={(data)=>{setSelectedStatus(data)}} isChecked={selectedStatus === "wont_fix"} />
                                            </div>
                                            {(selectedStatus === "closed" || selectedStatus === "wont_fix") && 
                                                <>
                                                    <p className="mb-4">Comments</p>
                                                    <textarea className="status-comments w-100" placeholder="Comments"></textarea>
                                                </>
                                            }
                                        </div>
                                        <div className="d-flex gap-3 m-2">
                                            <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                            {!modalLoading && <Button buttonText="Save" buttonType={"primary"} disableButton={selectedStatus === ""} buttonClicked={() => updateStatus()} />}
                                            {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                        </div>
                                    </div>
                                </Modal.Body>}
                                {modalType === "updateSeverity" && <Modal.Body>
                                    <div className="delete-organization-container">
                                        <h4>Update Severity</h4>
                                        <div className="organization-related-details p-4 m-2">
                                            <p className="mb-4">Please Select below option</p>
                                            <div className="update-severity-option d-flex mb-4">
                                                <RadioButton radioId={1} radioValue={"critical"} radioLabel={"Critical"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "critical"} />
                                                <RadioButton radioId={2} radioValue={"high"} radioLabel={"High"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "high"} />
                                                <RadioButton radioId={3} radioValue={"medium"} radioLabel={"Medium"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "medium"} />
                                            </div>
                                            <div className="update-severity-option d-flex mb-4">
                                                <RadioButton radioId={4} radioValue={"low"} radioLabel={"Low"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "low"} />
                                                <RadioButton radioId={5} radioValue={"informational"} radioLabel={"Informational"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "informational"} />
                                            </div>
                                        </div>
                                        <div className="d-flex gap-3 m-2">
                                            <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                            {!modalLoading && <Button buttonText="Save" buttonType={"primary"} disableButton={selectedSeverity === ""} buttonClicked={() => updateSeverity()} />}
                                            {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                        </div>
                                    </div>
                                </Modal.Body>}
                                {(modalType === "start" ||  modalType === "stop") && <Modal.Body>
                                    <div className="delete-organization-container">
                                        <h4>Update Retest</h4>
                                        <div className="organization-related-details p-4 m-2">
                                            {modalType === "start" && <p className="mb-4">Are you want to start retest?</p>}                                   
                                            {modalType === "stop" && <p className="mb-4">Are you want to stop retest?</p>}                                  
                                        </div>
                                        <div className="d-flex gap-3 m-2">
                                            <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                            {!modalLoading && <Button buttonText="Save" buttonType={"primary"} buttonClicked={() => updateRetest()} />}
                                            {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                        </div>
                                    </div>
                                </Modal.Body>}
                        </Modal>
                    </div>
                </div>
            </div> 
        </>        
    )
}


export default MisConfiguration;